export const utils = {
    getURLParams: function(URL) {
        var vars = {};
        URL.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
          vars[key] = decodeURI(value);
        }
      );
      return vars;
    }
}
